import { Group, IconButton, Link } from '@chakra-ui/react'
import type { FC } from 'react'
import { FiDownload } from 'react-icons/fi'

import Can from '@app/shared/authorization/can'
import EntityDeleteAttachmentButton from '@app/shared/entities/entityDeleteAttachmentButton'
import type { Attachment } from '@graphql/queries'

interface Props {
  attachment: Attachment
}

const ActionBar: FC<Props> = ({ attachment, ...rest }) => (
  <Group {...rest}>
    <IconButton aria-label="Download image" asChild size="xs">
      <Link href={attachment.url} rel="onoopener noreferrer" target="_blank">
        <FiDownload />
      </Link>
    </IconButton>
    <Can I="update" an="event">
      <EntityDeleteAttachmentButton attachmentId={attachment.id} entityId={attachment.entityId} />
    </Can>
  </Group>
)

export default ActionBar
